import { getElementSize } from '../../utils/index.ts';
import { PerspectiveCamera, WebGLRenderer } from 'three';

export interface Sizes {
  width: number;
  height: number;
}
export const sizes: Sizes = {
  width: window.innerWidth,
  height: window.innerHeight,
};

let camera: PerspectiveCamera;
let renderer: WebGLRenderer;
let resizeObserver: ResizeObserver;

export function resizeEventListener(
  _camera: PerspectiveCamera,
  _renderer: WebGLRenderer,
  rootElement: HTMLElement,
  container?: HTMLElement,
): void {
  camera = _camera;
  renderer = _renderer;

  resizeObserver = new ResizeObserver(() => {
    // Update sizes
    const size = getElementSize(container || document.body);
    const renderScale = Math.min(1, Math.sqrt((1024 * 768) / (size.width * size.height)));
    console.log('================resizeEventListener', renderScale);
    console.log('resize', size, container);
    // Update camera
    camera.aspect = size.width / size.height;
    camera.updateProjectionMatrix();

    const width = size.width * renderScale;
    const height = size.height * renderScale;
    renderer.setSize(width, height);
    renderer.domElement.style.transform = `scale(${1 / renderScale})`;

    renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2));
    rootElement.style.width = `${width}px`;
    rootElement.style.height = `${height}px`;
  });
  resizeObserver.observe(document.body);
}

export function clear(): void {
  resizeObserver.unobserve(document.body);
}
